<template>
  <abk-competences-list competences-type="connectedWithSkills"/>
</template>

<script>
import AbkCompetencesList from '../../../components/competences/AbkCompetencesList'

export default {
  name: 'CompetencesConnectedWithSkillsTab',
  components: { AbkCompetencesList },
  methods: {
    setHeader () {
      this.$store.dispatch('header/setHeader', {
        title: this.$t('views.competences.list_tabs.competences_connected_with_skills_tab.title'),
        subtitle: this.$t('views.competences.list_tabs.competences_connected_with_skills_tab.subtitle')
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setHeader()
    })
  }
}
</script>

<style scoped lang="scss">
</style>
